module.exports = __webpack_public_path__ + "static/hero-bg-a0a2c2f1f12e433f5f0ceac9216f1a84.jpg";